import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';

const SubTables = ({ config }) =>
  config.columns.map((_, columnIndex) => (
    // eslint-disable-next-line react/no-array-index-key
    <TableCell style={{ padding: '0' }} key={columnIndex}>
      <Table>
        <TableBody>
          {config.rows.map((row, rowIndex, rows) => (
            // eslint-disable-next-line react/no-array-index-key
            <TableRow key={rowIndex}>
              <TableCell
                style={
                  rows.length - 1 === rowIndex
                    ? {
                        paddingLeft: '0',
                        borderBottom: '0',
                      }
                    : {
                        paddingLeft: '0',
                      }
                }
              >
                <div style={{ paddingLeft: '16px' }}>{row[columnIndex]}</div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableCell>
  ));

export default SubTables;
